import type { FileConfig } from '../types/FileConfig';

/**
 * Configuration objects for Cortex tool file types
 * Each config defines how to parse a specific Cortex CSV file format
 */
export const CORTEX_CONFIGS: Record<string, FileConfig> = {
  CORTEX_SURVEY: {
    timeColumns: ['Time (seconds)', 'Survey Timestamp (seconds)', 'Time'], 
    expectedColumns: ['INC (degrees)', 'AZM (degrees)', 'GRAV (g)', 'MAGF (gauss)'], // Core survey columns from Cortex
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_SURVEY',
    dataType: 'survey'
  },
  CORTEX_GYRO_CONTINUOUS_MEAS: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['Gyro Gravity Toolface (degrees)', 'Gyro Toolface (degrees)', 'Gyro Inclination (degrees)'],
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_GYRO_CONTINUOUS_MEAS',
    dataType: 'timeseries'
  },
  CORTEX_GYRO_SURVEY: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['Gyro Azimuth (degrees)', 'Gyro Toolface (degrees)', 'Gyro Inclination (degrees)', 'Gyro Gravity Toolface (degrees)', 'Gyro Gravity Field (g)', 'Gyro Horizontal Rotation Rate (deg/hr)'],
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_GYRO_SURVEY',
    dataType: 'survey'
  },
  CORTEX_RAWSUR_F3: {
    timeColumns: [], // No explicit time columns - timestamps generated from sampling rate
    expectedColumns: ['AX', 'AY', 'AZ', 'MX', 'MY', 'MZ'], // Raw accelerometer and magnetometer data
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_RAWSUR_F3',
    dataType: 'timeseries',
    generateTimestamps: true,
    startTimeMetadataKey: 'Ranging Survey Date/Time',
    samplingRateMetadataKey: 'Sampling Rate'
  },
  CORTEX_RAWSUR_SEC: {
    timeColumns: [], // No explicit time columns - timestamps generated from sampling rate
    expectedColumns: ['AX', 'AY', 'AZ', 'MX', 'MY', 'MZ'], // Raw accelerometer and magnetometer data (secondary)
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_RAWSUR_SEC',
    dataType: 'timeseries',
    generateTimestamps: true,
    startTimeMetadataKey: 'Ranging Survey Date/Time',
    samplingRateMetadataKey: 'Sampling Rate'
  },
  CORTEX_SURVEY_SECONDARY: {
    timeColumns: ['Time (seconds)', 'Survey Timestamp (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['INC (degrees)', 'AZM (degrees)', 'GRAV (g)', 'MAGF (gauss)', 'DIPA (degrees)', 'GTFA (degrees)', 'MTFA (degrees)'], // Extended survey columns
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_SURVEY_SECONDARY',
    dataType: 'survey'
  },
  CORTEX_SYSTEM: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['System Event', 'Other Info'], // System event tracking
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_SYSTEM',
    dataType: 'timeseries'
  },
  CORTEX_VOLTAGES: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['bat1 min (V)', 'bat1 max (V)', 'bat1 mean (V)', 'bat2 min (V)', 'bat2 max (V)', 'bat2 mean (V)', 'BBUS min (V)', 'BBUS max (V)', 'BBUS mean (V)'], // Core voltage monitoring
    toolType: 'Cortex',
    fileType: 'EM_CORTEX_VOLTAGES',
    dataType: 'timeseries'
  }
};